import { render, staticRenderFns } from "./categoria.vue?vue&type=template&id=5ea0cd92"
import script from "./categoria.vue?vue&type=script&lang=js"
export * from "./categoria.vue?vue&type=script&lang=js"
import style0 from "./categoria.vue?vue&type=style&index=0&id=5ea0cd92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports